import React, { useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { base_url } from '../Api/Api';
import { Loader } from '../Common/Loader';

import Itemcategory from './Itemcategory';
import Itemcategoryskltn from './Itemcategoryskltn';
import { withRouter } from 'react-router';
import Cookies from 'universal-cookie';

const Homepage = (props) => {

    const [state, setState] = useState({
        data: [],
        statusCards: false
    })

    useEffect(() => {
        const cookies = new Cookies()
        
        if (cookies.get('api_key') == null) {
            props.history.push(`/entrance`)
        }


        base_url.get("education")
            .then(response => {
                setState({
                    ...state,
                    data: response.data,
                    statusCards: response.data.length == 0
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                        localStorage.clear()
                        window.location.reload()
                    }
                }
            })

    }, [])

    const handleSaveCategory = (id) => {
        const data = null;
        state.data.map((info) => {
            if (info.id == id) {
                localStorage.setItem('category', JSON.stringify({ ...info }));
                props.history.push("/education/category")
            }
        })
    }

    return (
        <div className="education">

            <div className="contain">
                <div className="body-instructpg">

                    <div className={`inner-education ${state.loader ? 'active' : ''}`}>
                        {state.data.length == 0 ?
                            state.statusCards ?
                                <span className="no-content">اطلاعاتی وجود ندارد</span>
                                :
                                <Itemcategoryskltn />
                            :
                            state.data.map((info) =>
                                <Itemcategory
                                    key={info.id}
                                    id={info.id}
                                    image={info.image}
                                    title={info.name}
                                    setCategory={() => handleSaveCategory(info.id)} />
                            )}
                    </div>

                </div>
            </div>
        </div>
    );
}

export default withRouter(Homepage);